import React from "react";
import IconAction from "../../../shared/components/generic/button/icon-action/icon-action";
import MonetaryUtils from "../../../shared/utils/MonetaryUtils";
import StatusIcon from "../../../shared/components/generic/status-icon/status-icon";
import DateUtils from "../../../shared/utils/DateUtils";
import CnpjUtils from "../../../shared/utils/CnpjUtils";
import {
	getStatusLabel,
	getAssessmentStatus
} from "../utils/assessment-view-utils";
import AssessmentBooleanCell from "../components/assessment-boolean-cell/assessment-boolean-cell";
import AssessmentDiscountCell from "../components/assessment-discount-cell/assessment-discount-cell";

export const apuracaoColumnsConfig = ({ onViewRules, showStatus = false } = {}) => [
	{
		key: "assessmentDate",
		label: "Data apuração",
		width: "150px",
		render: row => DateUtils.formatDateToBrazilian(row.assessmentDate)
	},
	...(showStatus ? [
		{
			key: "status",
			label: "Status",
			width: "140px",
			render: row => {
				const status = getAssessmentStatus(row.status);

				return (
					<span
						className={`apuracao-table__status apuracao-table__status--${status.variant}`}
					>
						{status.label}
					</span>
				);
			}
		}
	] : []),
	{
		key: "clientSize",
		label: "Tam.",
		width: "100px",
		render: row => (
			<span className="apuracao-table__client-size">
				{row.clientSize}
			</span>
		)
	},
	{
		key: "client",
		label: "Cliente",
		width: "180px"
	},
	{
		key: "cnpj",
		label: "CNPJ",
		width: "200px",
		render: row => CnpjUtils.partiallyHideCnpj(row.cnpj)
	},
	{
		key: "city",
		label: "Cidade",
		width: "160px"
	},
	{
		key: "state",
		label: "UF",
		width: "80px"
	},
	{
		key: "equipment",
		label: "Equipamento",
		width: "150px"
	},
	{
		key: "purchaseDate",
		label: "Data compra",
		width: "160px",
		render: row => DateUtils.formatDateToBrazilian(row.purchaseDate)
	},
	{
		key: "equipmentSaleValue",
		label: "Vl. venda equip.",
		width: "180px",
		render: row => MonetaryUtils.formatCurrency(row.equipmentSaleValue)
	},
	{
		key: "installmentsQuantity",
		label: "Qtd. parcelas",
		width: "140px"
	},
	{
		key: "discountInstallments",
		label: "Parc. p/ desc.",
		width: "190px"
	},
	{
		key: "baseline",
		label: "Baseline",
		width: "140px",
		render: row => MonetaryUtils.formatCurrency(row.baseline)
	},
	{
		key: "netSales",
		label: "Net Sales",
		width: "140px",
		render: row => MonetaryUtils.formatCurrency(row.netSales)
	},
	{
		key: "netSalesGrowth",
		label: "Cresc. Net Sales",
		width: "170px",
		render: row => MonetaryUtils.formatPercentage(row.netSalesGrowth)
	},
	{
		key: "baselineVxPers",
		label: "Baseline VX Pers.",
		width: "170px"
	},
	{
		key: "variluxResult",
		label: "Varilux Result.",
		width: "160px"
	},
	{
		key: "rulesGoals",
		label: "Metas regras",
		width: "150px",
		render: row => (
			<IconAction
				row={row}
				actions={[
					{
						key: "view-rules",
						variant: "view",
						title: "Visualizar metas e regras",
						ariaLabel: "Visualizar metas e regras",
						onClick: currentRow => onViewRules?.(currentRow)
					}
				]}
			/>
		)
	},
	{
		key: "netSalesGoal",
		label: "Meta Net Sales",
		width: "170px",
		render: row => (
			<AssessmentBooleanCell value={row.netSalesGoal} />
		)
	},
	{
		key: "variluxGoal",
		label: "Meta Varilux",
		width: "160px",
		render: row => (
			<AssessmentBooleanCell value={row.variluxGoal} />
		)
	},
	{
		key: "groupGoal",
		label: "Meta Grupo",
		width: "150px",
		render: row => (
			<AssessmentBooleanCell value={row.groupGoal} />
		)
	},
	{
		key: "latePayment",
		label: "Inadimplência",
		width: "170px",
		render: row => (
			<AssessmentBooleanCell value={row.latePayment} />
		)
	},
	{
		key: "grantedDiscountPercentage",
		label: "% Desc. concedido",
		width: "200px",
		render: row => (
			<AssessmentDiscountCell
				value={row.grantedDiscountPercentage}
			/>
		)
	},
	{
		key: "originalInstallmentValue",
		label: "Vl. parcela orig.",
		width: "190px",
		render: row => MonetaryUtils.formatCurrency(row.originalInstallmentValue)
	},
	{
		key: "installmentDiscountValue",
		label: "Vl. desc. parcela",
		width: "190px",
		render: row => MonetaryUtils.formatCurrency(row.installmentDiscountValue)
	},
	{
		key: "installmentValueWithDiscount",
		label: "Vl. parcela c/ desc.",
		width: "210px",
		render: row => (
			<span className="apuracao-table__discounted-installment-value">
				{MonetaryUtils.formatCurrency(row.installmentValueWithDiscount)}
			</span>
		)
	},
	{
		key: "approvalDate",
		label: "Aprovado",
		width: "160px",
		render: row =>
			DateUtils.formatDateToBrazilian(
				row.approvalDate
			)
	},
	{
		key: "appliedOracle",
		label: "Aplic. Oracle",
		width: "160px",
		render: row =>
			DateUtils.formatDateToBrazilian(row.appliedOracleDate)
	}
];